import { createContext, useContext, type ReactNode } from 'react';

/** Where a picker's list is looked after (W29): the admin page for the list, when the viewer may use it. */
export interface ManageListLink {
  href: string;
  label?: ReactNode;
}

type Resolve = (kind: string) => ManageListLink | undefined;

const ManageListContext = createContext<Resolve | null>(null);

/** The app says, per list kind, where it is managed (and hides it from those who may not). */
export function PickerManageListProvider({ resolve, children }: { resolve: Resolve; children: ReactNode }) {
  return <ManageListContext.Provider value={resolve}>{children}</ManageListContext.Provider>;
}

export function usePickerManageList(kind: string | undefined): ManageListLink | undefined {
  const resolve = useContext(ManageListContext);
  return kind && resolve ? resolve(kind) : undefined;
}
